import { useTranslation } from "react-i18next";
import { ContractModel } from "src/api/contract/contract-types";
import BaseAbstractModal from "src/components/BaseAbstractModal";
import { DocumentProofRequest } from "../../components/types";
import { validateIdentityNum } from "../switchInvoice/CashBillForm";

// 결제 액션 버튼 Props 타입
export type Props = {
  isVerifiedPaymentKey: boolean; // 결제키 검증 여부
  isMobile: boolean; // 모바일 여부
  isAsk: boolean; // 문의하기 여부
  contract: ContractModel; // 계약 정보
  phoneNumber: string; // 전화번호
  primaryQuotationName: any; // 주요 견적서명
  pgcode: string; // 결제 수단 코드
  documentProofRequest: DocumentProofRequest; // 증빙서류 요청 정보
  handleClickPaymentS2: (pgcode: string, documentProofRequest: DocumentProofRequest) => void; // S2 결제 핸들러
  setIsAsk: (isAsk: boolean) => void; // 문의하기 상태 설정 핸들러
  paymentDisabled?: boolean; // 결제 불가능 여부
  setIdentityNumError?: (error: string) => void; // 신분증 번호 에러 설정 핸들러
};

// 결제 액션 버튼 컴포넌트
// 결제 가능 여부에 따라 다른 UI를 표시하는 컴포넌트
export const PaymentActionButton = ({
  isVerifiedPaymentKey,
  isMobile,
  isAsk,
  contract,
  phoneNumber,
  primaryQuotationName,
  pgcode,
  documentProofRequest,
  handleClickPaymentS2,
  setIsAsk,
  paymentDisabled = false,
  setIdentityNumError,
}: Props) => {
  const { t } = useTranslation("contract");
  // 결제하기 버튼 클릭 핸들러
  const handlePaymentClick = () => {
    // 증빙신청이 선택되고 현금영수증인 경우 유효성 검사 수행
    if (
      (documentProofRequest as any)?.isRequest &&
      documentProofRequest?.expenseProofType === "CASHBILL" &&
      documentProofRequest?.identityType &&
      setIdentityNumError
    ) {
      const error = validateIdentityNum(documentProofRequest?.identityNum || "", documentProofRequest?.identityType);
      if (error) {
        setIdentityNumError(error);
        return; // 에러가 있으면 결제 진행하지 않음
      }
    }
    handleClickPaymentS2(pgcode, documentProofRequest);
  };
  return (
    <>
      <div className="base-floating-btn-wrap px0">
        <p className="mb10 w-100 font13 text-primary1 font-weight-400 text-center">{t("detail.paymentConsent")}</p>
        <button type="button" className="base-btn" onClick={handlePaymentClick} disabled={paymentDisabled}>
          {t("detail.pay")}
        </button>
      </div>
    </>
  );
};
